import { ParaglideMessage } from '@inlang/paraglide-js-react';
import { openSellerSkus } from 'virtual:anyapi-seller-skus';
import { m } from '../../paraglide/messages';

/** The open set is the manifest fact `seller.open === true`, the one
 *  scripts/gen-seller-pages.mjs publishes a seller page for. */
const OPEN_SKUS = new Set(openSellerSkus);

/** The SKU's seller page, mirroring the Mintlify site proxied under `/docs`, or
 *  null when the SKU is not open to sellers. */
const sellerSchemaHref = (sku: string): string | null =>
  OPEN_SKUS.has(sku) ? `/docs/sell/apis/${sku}` : null;

/** Sends a would-be seller from the response fields to the full schema their
 *  endpoint must return. Renders nothing for a SKU not open to sellers. */
export const SellerSchemaLink = ({ sku }: { sku: string }) => {
  const href = sellerSchemaHref(sku);
  if (!href) return null;
  return (
    <p className="mt-6 text-13 text-text-3">
      <ParaglideMessage
        message={m.endpoint_seller_schema_link}
        markup={{
          link: ({ children }) => (
            <a className="text-accent hover:underline" href={href}>
              {children}
            </a>
          ),
        }}
      />
    </p>
  );
};
